import { render, staticRenderFns } from "./UserAccountFormComp.vue?vue&type=template&id=6d37ee22&scoped=true&"
import script from "./UserAccountFormComp.vue?vue&type=script&lang=js&"
export * from "./UserAccountFormComp.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountFormComp.vue?vue&type=style&index=0&id=6d37ee22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d37ee22",
  null
  
)

export default component.exports